import truckImg from '../images/truck.png';

// dropsBeforeYou → how far along the route the truck animates to
// drops=3 → 25%, drops=2 → 33%, drops=1 → 50%, drops=0 → 97% (slow)
export function getAnimTarget(drops) {
  if (drops === 0) return {to: 0.97, duration: 45000};
  return {to: 1 / (drops + 1), duration: 20000};
}

export function easeInOut(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function segmentLength(a, b) {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  return Math.sqrt(dx * dx + dy * dy);
}

export function bearing(a, b) {
  const toRad = d => (d * Math.PI) / 180;
  const toDeg = r => (r * 180) / Math.PI;
  const dLng = toRad(b[0] - a[0]);
  const lat1 = toRad(a[1]);
  const lat2 = toRad(b[1]);
  const y = Math.sin(dLng) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
  return (toDeg(Math.atan2(y, x)) + 360) % 360;
}

export function positionAtProgress(coords, progress) {
  if (progress <= 0)
    return {lngLat: coords[0], deg: bearing(coords[0], coords[1])};
  if (progress >= 1)
    return {
      lngLat: coords[coords.length - 1],
      deg: bearing(coords[coords.length - 2], coords[coords.length - 1]),
    };

  let total = 0;
  const lengths = [];
  for (let i = 1; i < coords.length; i++) {
    total += segmentLength(coords[i - 1], coords[i]);
    lengths.push(total);
  }

  const target = total * progress;
  let prev = 0;
  for (let i = 0; i < lengths.length; i++) {
    if (lengths[i] >= target) {
      const t = (target - prev) / (lengths[i] - prev);
      const a = coords[i];
      const b = coords[i + 1];
      return {
        lngLat: [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t],
        deg: bearing(a, b),
      };
    }
    prev = lengths[i];
  }
  return {lngLat: coords[coords.length - 1], deg: 0};
}

export const makeTruckEl = () => {
  const wrapper = document.createElement('div');
  wrapper.style.cssText = 'width:72px;height:30px;';
  const img = document.createElement('img');
  img.src = truckImg;
  img.style.cssText =
    'width:72px;height:30px;cursor:pointer;transform-origin:center;display:block;';
  wrapper.appendChild(img);
  return {wrapper, img};
};

export function getDropsStatus(tracking, orderStatus) {
  if (!tracking || tracking.dropsBeforeYou == null) return orderStatus;
  const d = tracking.dropsBeforeYou;
  if (d === 0) return 'Driver is almost there';
  if (d <= 3) return 'Less than 3 stops away';
  if (d <= 5) return 'Less than 5 stops away';
  const bucket = Math.ceil(d / 5) * 5;
  return `Less than ${bucket} stops away`;
}

export const makeDestEl = () => {
  const el = document.createElement('div');
  el.style.cssText =
    'width:16px;height:16px;border-radius:50%;background:#dc2626;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);cursor:pointer;';
  return el;
};
